import React from 'react';
import { Helmet } from 'react-helmet';

function Twitter() {
  return (
    <Helmet>
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@fluicity" />
      <meta name="twitter:creator" content="@fluicity" />
    </Helmet>
  );
}

export default Twitter;
